import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { ConfirmProvider } from "./context/ConfirmContext";
import { UIProvider } from "./context/UIContext";
import { BrandingProvider } from "./context/BrandingContext";

const routerBasename = typeof __BASE_PATH__ === "string" && __BASE_PATH__ !== "/" ? __BASE_PATH__ : undefined;


function App() {
  return (
    <BrowserRouter basename={routerBasename}>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <BrandingProvider>
            <ToastProvider>
              <ConfirmProvider>
                <UIProvider>
                  <AppRoutes />
                </UIProvider>
              </ConfirmProvider>
            </ToastProvider>
          </BrandingProvider>
        </AuthProvider>
      </I18nextProvider>
    </BrowserRouter>
  );
}

export default App;